module.exports = __webpack_public_path__ + "img/illustration-register-v2-dark.8e9b576c.png";